import AppHeader from "./components/app-header/AppHeader";
import AudienceCompare from "./pages/audience-compare/AudienceCompare";
import css from "./AuthenticatedApp.module.css";

/**
 * Renders the app once a user is authenticated.
 */
const AuthenticatedApp = () => {
  return (
    <>
      <AppHeader />
      <main className={css.main}>
        <AudienceCompare />
      </main>
    </>
  );
};

export default AuthenticatedApp;
